import { defineStyleConfig } from "@chakra-ui/react";

const DrawerCloseButton = defineStyleConfig({ defaultProps: { size: "md" } });

export default DrawerCloseButton;
